import { AppUpdatePage } from '@/features/access/pages/app/AppUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/app/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_app.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: AppUpdatePage,
})
